import fetchProvider from "@data-access/co-so-dao-tao-provider";
import baseStore from "../base-store";

export default {
  ...baseStore({
    fetchProvider,
    storeName: "coSoDaoTao",
    initStore: {},
  }),
};
